import { render, staticRenderFns } from "./discount-list.vue?vue&type=template&id=efa582c2&scoped=true"
import script from "./discount-list.vue?vue&type=script&lang=js"
export * from "./discount-list.vue?vue&type=script&lang=js"
import style0 from "./discount-list.vue?vue&type=style&index=0&id=efa582c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa582c2",
  null
  
)

export default component.exports